var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isSubscribed,
          expression: "!isSubscribed"
        }
      ],
      staticClass: "newsletter py25 px15 bg-cl-transparent"
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "newsletter-content m0 row middle-sm start-md" },
          [
            _c(
              "div",
              { staticClass: "col-md-8 col-xs-12" },
              [
                _c("cms-block-chunk", {
                  staticClass: "h3 cl-dark weight-400 m0",
                  attrs: { identifier: "c_BOX_NEWSLETTER" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "newsletter-button col-md-4 col-xs-12 end-md" },
              [
                _c(
                  "button-outline",
                  {
                    attrs: {
                      color: "cl-dark dark",
                      "data-testid": "openNewsletterButton"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.showNewsletterPopup($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("Subscribe")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.loadNewsletterPopup ? _c("newsletter-popup") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }